import _taggedTemplateLiteral from "/home/jenkins/workspace/terra.b2c.webui.register_staging/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n         white-space: nowrap;\n         \n            ", "\n                ", "\n                ", "\n        "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled, { css } from 'styled-components';
export var StyledHeaderGroup = styled.div(_templateObject(), function (props) {
  return css(_templateObject2(), props.left ? "\n                overflow-x: auto;\n                flex: 2;         \n                display: flex;\n                justify-content: flex-start;\n                align-items: center;\n                " : '', props.center ? "\n                    flex: 1;\n                    display: flex;\n                    justify-content: center;\n                    align-items: center;\n                    " : '', props.right ? "\n                    flex: 1;\n                    display: flex;\n                    justify-content: flex-end;\n                    align-items: center;\n                    margin-right: -".concat(props.theme.components.header.group.margin, ";\n                    ") : '');
});